// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bel_a bhg_bk bhg_bl bhg_bo","SwipeLeftToClose--animating":"bel_b"};